import React, { useState } from 'react';

const CATEGORY_ICONS = {
  dresses: '👗',
  ethnic: '🥻',
  tops: '👚',
  bottoms: '👖',
  footwear: '👠',
  accessories: '👜',
  outerwear: '🧥'
};

const CATEGORY_LABELS = {
  dresses: 'Dresses & Sets',
  ethnic: 'Ethnic Wear',
  tops: 'Tops',
  bottoms: 'Bottoms',
  footwear: 'Footwear',
  accessories: 'Accessories',
  outerwear: 'Outerwear'
};

const PLATFORM_COLORS = {
  myntra: '#FF3F6C',
  nykaa: '#FC2779',
  tatacliq: '#6C3C97',
  meesho: '#9E11C8'
};

function ProductCard({ product }) {
  const [imgError, setImgError] = useState(false);
  const [hovered, setHovered] = useState(false);

  const handleClick = () => {
    window.open(product.product_url, '_blank');
  };

  return (
    <div
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        background: '#fff',
        borderRadius: '12px',
        overflow: 'hidden',
        border: '1px solid #f0f0f0',
        textDecoration: 'none',
        color: 'inherit',
        transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
        boxShadow: hovered ? '0 8px 24px rgba(0,0,0,0.12)' : 'none',
        transition: 'transform 0.2s, box-shadow 0.2s',
        flex: '1',
        minWidth: '140px',
        maxWidth: '180px',
        cursor: 'pointer'
      }}
    >
      <div style={{
        width: '100%',
        aspectRatio: '3/4',
        background: '#f8f8f8',
        overflow: 'hidden'
      }}>
        {!imgError ? (
          <img
            src={product.image_url}
            alt={product.name}
            onError={() => setImgError(true)}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        ) : (
          <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '32px'
          }}>
            👕
          </div>
        )}
      </div>

      <div style={{ padding: '10px' }}>
        <div style={{
          fontSize: '10px',
          color: '#999',
          textTransform: 'uppercase',
          fontWeight: '600',
          marginBottom: '2px'
        }}>
          {product.brand}
        </div>
        <div style={{
          fontSize: '12px',
          color: '#333',
          fontWeight: '500',
          marginBottom: '6px',
          lineHeight: '1.3',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden'
        }}>
          {product.name}
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}>
          <span style={{
            fontSize: '14px',
            fontWeight: '700',
            color: '#333'
          }}>
            Rs.{product.price ? product.price.toLocaleString() : '0'}
          </span>
          {product.was_price > product.price && (
            <span style={{
              fontSize: '11px',
              color: '#999',
              textDecoration: 'line-through'
            }}>
              Rs.{product.was_price ? product.was_price.toLocaleString() : '0'}
            </span>
          )}
        </div>
        {product.discount_percent && product.discount_percent !== '0% off' && (
          <div style={{
            fontSize: '11px',
            color: '#22c55e',
            fontWeight: '600',
            marginTop: '2px'
          }}>
            {product.discount_percent}
          </div>
        )}
      </div>

      <div style={{
        padding: '8px 10px',
        background: '#FF6B35',
        color: '#fff',
        textAlign: 'center',
        fontSize: '12px',
        fontWeight: '600'
      }}>
        Buy on Ajio
      </div>
    </div>
  );
}

function OutfitCard({ outfit, onClose }) {
  if (!outfit) return null;

  const hasItems = Object.values(outfit.items).some(
    function(items) { return items && items.length > 0; }
  );

  return (
    <div style={{
      background: 'linear-gradient(135deg, #fff9f7 0%, #fff5f0 100%)',
      borderRadius: '20px',
      border: '1px solid #ffe4d6',
      padding: '24px',
      marginTop: '16px',
      position: 'relative'
    }}>

      {onClose && (
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: '#999'
          }}
        >
          X
        </button>
      )}

      <div style={{ marginBottom: '20px' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          marginBottom: '8px'
        }}>
          <span style={{ fontSize: '28px' }}>✨</span>
          <div>
            <h2 style={{
              margin: 0,
              fontSize: '20px',
              fontWeight: '700',
              color: '#1a1a1a',
              textTransform: 'capitalize'
            }}>
              {outfit.occasion} Outfit
            </h2>
            <div style={{
              fontSize: '13px',
              color: '#666',
              marginTop: '2px'
            }}>
              {outfit.gender === 'women' ? '👩' : '👨'} {outfit.gender}
              {outfit.budget && (
                <span> · Budget Rs.{outfit.budget.toLocaleString()}</span>
              )}
            </div>
          </div>
        </div>

        <div style={{
          display: 'inline-block',
          background: '#FF6B35',
          color: '#fff',
          padding: '4px 12px',
          borderRadius: '20px',
          fontSize: '12px',
          fontWeight: '500'
        }}>
          {outfit.vibe}
        </div>
      </div>

      <div style={{
        background: '#fff8f0',
        border: '1px solid #ffd9bb',
        borderRadius: '12px',
        padding: '12px 16px',
        marginBottom: '24px',
        display: 'flex',
        gap: '10px',
        alignItems: 'flex-start'
      }}>
        <span style={{ fontSize: '18px' }}>💡</span>
        <p style={{
          margin: 0,
          fontSize: '13px',
          color: '#7a4a2a',
          lineHeight: '1.5',
          fontStyle: 'italic'
        }}>
          {outfit.style_tip}
        </p>
      </div>

      {hasItems ? (
        Object.entries(outfit.items).map(function(entry) {
          var category = entry[0];
          var products = entry[1];
          if (!products || products.length === 0) return null;

          return (
            <div key={category} style={{ marginBottom: '24px' }}>
              <h3 style={{
                margin: '0 0 12px 0',
                fontSize: '15px',
                fontWeight: '600',
                color: '#333',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <span>{CATEGORY_ICONS[category] || '👔'}</span>
                <span>{CATEGORY_LABELS[category] || category}</span>
                <span style={{
                  fontSize: '12px',
                  color: '#999',
                  fontWeight: '400'
                }}>
                  ({products.length} options from Ajio)
                </span>
              </h3>

              <div style={{
                display: 'flex',
                gap: '12px',
                overflowX: 'auto',
                paddingBottom: '8px'
              }}>
                {products.map(function(product, idx) {
                  return <ProductCard key={idx} product={product} />;
                })}
              </div>
            </div>
          );
        })
      ) : (
        <div style={{
          textAlign: 'center',
          padding: '40px',
          color: '#999'
        }}>
          No products found. Try different filters!
        </div>
      )}

      <div style={{
        borderTop: '1px solid #ffe4d6',
        paddingTop: '20px',
        marginTop: '8px'
      }}>
        <h3 style={{
          margin: '0 0 12px 0',
          fontSize: '14px',
          fontWeight: '600',
          color: '#666'
        }}>
          More Options On
        </h3>

        <div style={{
          display: 'flex',
          gap: '10px',
          flexWrap: 'wrap'
        }}>
          {Object.entries(outfit.platform_links || {}).map(function(entry) {
            var platform = entry[0];
            var data = entry[1];
            return (
              <div
                key={platform}
                onClick={function() {
                  window.open(data.affiliate || data.url, '_blank');
                }}
                style={{
                  padding: '8px 16px',
                  borderRadius: '20px',
                  background: PLATFORM_COLORS[platform] || '#333',
                  color: '#fff',
                  fontSize: '13px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                {data.name}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default OutfitCard;